import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getProductById, defaultProductData } from '@/api/products';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import ProductGeneralTab from './ProductGeneralTab.vue';
import ProductCategoryTab from './ProductCategoryTab.vue';
import ProductAttributeTab from './ProductAttributeTab.vue';
import ProductVariationTab from './ProductVariationTab.vue';
import ProductImagesTab from './ProductImagesTab.vue';
import ProductAdvanceTab from './ProductAdvanceTab.vue';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, defaultProductData);
    this.activeIndex = 0;
    this.stepsOptions = [{
      title: 'General',
      status: 'process',
      prevStatus: 'wait',
      description: 'Description goes here',
      icon: 'el-icon-edit',
      component: ProductGeneralTab
    }, {
      title: 'Category',
      status: 'wait',
      prevStatus: 'wait',
      description: 'Description goes here',
      icon: 'el-icon-notebook-2',
      component: ProductCategoryTab
    }, {
      title: 'Images',
      status: 'wait',
      prevStatus: 'wait',
      description: 'Description goes here',
      icon: 'el-icon-picture',
      component: ProductImagesTab
    }, {
      title: 'Advanced',
      status: 'wait',
      prevStatus: 'wait',
      description: 'Description goes here',
      icon: 'el-icon-setting',
      component: ProductAdvanceTab
    }];
  }
  get lang() {
    return AppModule.language;
  }
  activated() {
    if (this.isEdit) {
      this.fetchData();
    } else {
      this.formData = Object.assign({}, defaultProductData);
      this.checkIfVariationsTabRequired();
    }
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData() {
    try {
      let id = parseInt(this.$route.params && this.$route.params.id || '0');
      if (this.formData.id) {
        id = this.formData.id;
      }
      const data = await getProductById(id, {
        sort: 'productsImage.priority,ASC'
      });
      if (data.taxId) {
        data.taxId = parseInt(data.taxId);
      }
      this.formData = data;
      // Just for test
      const title = this.formData.name;
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
      this.checkIfVariationsTabRequired();
    } catch (err) {} // eslint-disable-line  no-empty
  }
  checkIfVariationsTabRequired() {
    const variationsOption = [{
      title: 'Attributes',
      status: 'wait',
      prevStatus: 'wait',
      description: 'Description goes here',
      icon: 'el-icon-document',
      component: ProductAttributeTab
    }, {
      title: 'Variations',
      status: 'wait',
      prevStatus: 'wait',
      description: 'Description goes here',
      icon: 'el-icon-s-grid',
      component: ProductVariationTab
    }];
    if (this.formData.productType === 'simple') {
      // check if attribute exist at index 2
      if (this.stepsOptions[2].title === variationsOption[0].title) {
        this.stepsOptions.splice(2, 2); // remove Attribute & Variation Tab
      }
    } else {
      // add only if not present
      if (this.stepsOptions[2].title !== variationsOption[0].title) {
        this.stepsOptions.splice(2, 0, variationsOption[0], variationsOption[1]);
      }
    }
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  stepClick(index) {
    // check if not yet saved & still in first tab
    if (!this.isEdit && this.activeIndex === 0) {
      if (index > 0) {
        this.$message({
          message: 'Kindly save product before managing ' + this.stepsOptions[index].title,
          type: 'warning'
        });
      }
      return false;
    }
    this.stepsOptions[this.activeIndex].status = this.stepsOptions[this.activeIndex].prevStatus;
    this.activeIndex = index;
    this.stepsOptions[this.activeIndex].status = 'process';
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
default_1 = __decorate([Component({
  name: 'ProductDetail',
  components: {
    ProductGeneralTab,
    ProductCategoryTab
  }
})], default_1);
export default default_1;